// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__cUvBW","icon":"styles_icon__ovNTr","title":"styles_title__zz3Sm","metric":"styles_metric__z_U_F"};